<template>
  <div class="container mb-50">
    <b-row class="w-100">
      <h1 class="w-100">
        <b-icon icon="table"></b-icon> Academic Calendar
        <div class="float-right" style="margin-top: -62px">
          <b-button
            v-b-modal.modal-help
            v-b-tooltip.hover
            title="Help"
            class="help"
          >
            <b-icon icon="question-square-fill"></b-icon> Help</b-button
          >

 <Help id="13" />

        </div>
      </h1>
    </b-row>
    <b-row class="w-100">
      <div class="panal mt-20 w-100">
        <div class="panal-header">Your Full semester Calendar</div>
        <div class="panal-body">
          <div class="row">
            <div class="col-md-2">
              <b-list-group>
                <b-list-group-item active
                  >Calendar Information</b-list-group-item
                >
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  Lecture
                  <b-badge variant="warning" pill>Lecture</b-badge>
                </b-list-group-item>
                <b-list-group-item
                  class="d-flex justify-content-between align-items-center"
                >
                  Lab
                  <b-badge variant="primary" pill>Lab</b-badge>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div class="col-md-10">
              <FullCalendar :options="calendarOptions" />
            </div>
          </div>
          <div class="float-right col-md-2">
            <router-link
              to="/Schedule"
              tag="button"
              class="btn btn-primary btn-block"
              >View Basic Table</router-link
            >
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </b-row>

   <b-modal
      id="subjectModal"
      size="lg"
      ok-only
      :title="details.CourseName"
    >
      <div class="row">
        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Course Name</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CourseName }}</div>
        </div>
        <div class="clearfix"></div>

        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Course Code</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CourseCode }}</div>
        </div>
        <div class="clearfix"></div>

        <div class="col-md-3 col-sm-12 mt-2">
          <div class="profileData">Credit Hours</div>
        </div>
        <div class="col-md-9 col-sm-12 mt-2">
          <div class="profileData2">{{ details.CreditHours }}</div>
        </div>
        <div class="clearfix"></div>
        

      </div>
      <div class="panel  mt-2" v-for="(item,i) in details.SectionsList" :key="i">
          <div class="panel panel-primary">
              <div class="panel-headder">Type name :  {{ item.TypeNameEN }}</div>
              <div class="panel-body">
                                     <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                        <tr>
                        <th scope="col" >WeekDay</th>
                        <th scope="col" >StartTime</th>
                    
                        <th scope="col" >EndTime</th>
                        
                        <th scope="col" >BuildingName</th>
                        
                        <th scope="col" >RoomName</th>
                        <th scope="col" >professor Name</th>
                        
                        </tr>
                        </thead>
                    <tbody >
                           

        <tr  v-for="time in item.ScheduleLst" v-bind:key="time.Serial">
        <td> {{time.WeekDay}} </td>
        <td> {{time.StartTime}} </td>
           
        <td> {{time.EndTime}} </td>
        <td v-if="time.IsOnline === true"> {{time.BuildingName == null ? "Online" : time.BuildingName }} </td>
        <td v-else> {{time.BuildingName == null ? "--" : time.BuildingName }}  </td>
        <td> {{time.IsOnline == true ?  time.RoomName  == null ? 'Online'  : time.RoomName : time.RoomName}} </td>
        <td> {{time.ProfessorLst.map(z=> z.Name).join('-')}} </td>
        
        
          
        
        </tr>

        
    </tbody>
   </table>
              </div>
          </div>
          
          
        </div>
        <div class="clearfix"></div>
    </b-modal>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";

import BasicSchedule from "../../services/student/studentDataServices";
//import ApplicantService from '../../services/Applicant/Applicant.service';
import Help from '../../components/Help.vue';

export default {
  components: {
    FullCalendar,
    Help,
  },
  data() {
    return {
      info:"",
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: "dayGridMonth",

        editable: false,
        selectable: false,
        selectMirror: false,
        dayMaxEvents: false,
        eventClick: this.handleeventClick,
        events: [],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
       
        slotMinTime: "08:00:00",
        slotMaxTime: "20:00:00",
      },
      basicSchedule: [],
      Weekdays: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      selectedEvent: [],
      details :[] ,
      windowWidth: window.innerWidth
    };
  },
  methods: {
    handleeventClick: function ({ event }) {
      this.selectedEvent = this.basicSchedule.filter(
        (x) => x.CourseID == event.id 
      );
      this.details = this.selectedEvent[0]
      console.log(this.selectedEvent);
      console.log(event);
      this.$bvModal.show("subjectModal");
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  beforeMount() {
    //
    BasicSchedule.getStudentSchedualeNew(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.basicSchedule = Response.data;
        this.calendarOptions.events = [];
        this.basicSchedule.forEach(type =>{

        type.SectionsList.forEach((item) => {
          item.ScheduleLst.forEach(event=>{
          this.calendarOptions.events.push({
            id: type.CourseID,
            title: type.CourseName,

            startTime: event.StartTime,
            endTime: event.EndTime,
            startRecur: "2023-01-01",
            endRecur: "2023-05-01",
            daysOfWeek: [this.Weekdays.indexOf(event.WeekDay)],
            extendedProps: { day: event.WeekDay },
            backgroundColor: item.TypeNameEN == "LCTR" ? "orange" : "",
            allDay: false,
            classNames: ["eventClass"],
          });
          })
      })
      });
        // eslint-disable-next-line no-console
        //console.log("Basic Schedule => ", Response.data);
      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status)

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    );
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    screenWidth(){
      return this.windowWidth
    }
  },
   mounted() {
     this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    //  let id = 13;

    // ApplicantService.GetHelpPages(id).then(response => {
    //     this.info = response.data
    //   });
    let  cal = document.getElementsByClassName('fc-toolbar')[0] 
    if(this.screenWidth < 600){
   
      cal.style.display='block'
  }else{
    cal.style.display='flex'
  }
   }
};
</script>

<style  scoped>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.mb-50 {
  margin-bottom: 50px;
}
.fc .fc-timegrid-slot {
  height: 2.5em !important;
}
.eventClass {
  padding: 5px !important;
  font-family: Arial !important;
  font-size: 16px !important;
}
.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none;
  }
  .fc .fc-toolbar{
    overflow: scroll !important;
     display: block !important;
  }
  .fc .fc-header-toolbar .fc-toolbar .fc-toolbar-ltr{
    display: block !important;
  }
  .fc .fc-toolbar.fc-header-toolbar{
    display: block !important;
  }
}

.profileData {
  border: 1px dotted #646464;
  color: #285475;
  padding: 3px 10px;
  font-weight: 700;
}

.profileData2 {
  border: 1px dotted #646464;
  color: #ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix {
  clear: both;
  display: table;
}
.line1 {
  border-top: 1px dotted #285475;
  border-bottom: 1px dotted #285475;
  height: 10px;

  float: left;
  margin: 57px 20px;
}

@media screen and (max-width: 1024px) {
  .line1 {
    display: none;
  }
  h1{
    font-size: 23px;
  }
  
}
</style>>

